module.exports = __webpack_public_path__ + "static/media/img2.2cfb4e1b.jpg";